import { withAuthHeaders } from "./auth";

export const fetchRecommendationByAppointment = async (apptId, userID, signal) => {
  const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/recommendations/${apptId}?userID=${userID}`, {
    headers: withAuthHeaders(),
    signal,
  });
  if (!response.ok) {
    throw new Error('Failed to fetch recommendations');
  }
  return response.json();
};

export const postRecommendationsToAthena = async (apptId, email, textPayload, encounterId, practiceID) => {
  const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/athena/${email}/encounter/${encounterId}/post-recommendations`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      id: `${email}_${apptId}_recommendations`,
      practiceID: practiceID,
      patientinstructions: textPayload
    }), 
  });
 
  if (!response.ok) {
    throw new Error('Failed to post recommendations to Athena');
  }
  return response.json();
};